<template>
  <md-card style="min-width:120px;max-width:150px;">
    <load-overlay v-if="downloading" style="position:absolute;" />

    <md-card-content>
      <img src="@/assets/PDF_W10.png" />
    </md-card-content>
    <md-card-actions>
      <md-button class="md-raised md-accent" @click="$emit('click')">Download</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
  import LoadOv from '@/components/LoadOverlay';

  export default {
    name: 'download-pdf',
    props: {
      downloading: Boolean
    },
    components: {
      'load-overlay': LoadOv
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DownloadPdf.vue